import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Store from "../store/index"
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta:{id:1,title:"داشبورد",Auth:true}
  },
  {
    path: "/manage/users",
    name: "sysuser",
    meta:{id:2,title:"لیست کاربران",Auth:true},
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/user/sysuser.vue")
  },
  {
    path: "/manage/customers",
    name: "customers",
    meta:{id:1090,title:"لیست مشتریان",Auth:true},
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/user/csmuser.vue")
  },
  {
    path: "/manage/customers/category",
    name: "customers",
    meta:{id:789654,title:"لیست دسته بندی مشتریان",Auth:true},
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/user/category.vue")
  },
  {
    path: "/manage/customers/detail/:id",
    name: "csmdetaile",
    meta:{id:1090,title:"لیست مشتریان",Auth:true},
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/user/detail.vue")
  },
  {
    path: "/manage/category/product/brands",
    name: "prodbrands",
    meta:{id:3,title:"لیست برند ها",Auth:true},
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/category/product/product-brand.vue")
  },
  {
    path: "/manage/category/product/category",
    name: "prodcats",
    meta:{id:4,title:"دسته بندی محصولات",Auth:true},
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/category/product/product-category.vue")
  },
  // {
  //   path: "/manage/category/product/digital/category",
  //   meta:{id:3,title:"لیست ناشران"},
  //   name: "digitalprodcats",
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/category/product/digital-category.vue")
  // },
  // {
  //   path: "/manage/category/training/category",
  //   name: "trainingcategory",
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/category/training/training-category.vue")
  // },
  // {
  //   path: "/manage/basesetting/product/energyusage",
  //   name: "energyusage",
  //   meta:{id:1019,title:"مدیریت  مصرف انرژی ",Auth:true},
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/basesetting/energyusage.vue")
  // },
  // {
  //   path: "/manage/basesetting/product/boxgiftwrapper",
  //   name: "boxwrapper",
  //   meta:{id:1075,title:"مدیریت   کادو پیچ محصولات ",Auth:true},
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/basesetting/boxwrapper.vue")
  // },
  // {
  //   path: "/manage/basesetting/product/manufacturcuntry",
  //   name: "manufacturcuntry",
  //   meta:{id:1018,title:"مدیریت کشور سازنده ",Auth:true},
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/basesetting/manufacturecuntry.vue")
  // },
  {
    path: "/manage/basesetting/product/color",
    name: "colors",
    meta:{id:1017,title:"مدیریت رنگ ها",Auth:true},
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/basesetting/product-colors.vue")
  },
  {
    path: "/manage/basesetting/headernotify",
    name: "headernotify",
    meta:{id:1071,title:"مدیریت  اطلاعیه های هدر",Auth:true},
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/basesetting/headernotify.vue")
  },
  {
    path: "/manage/basesetting/product/attribute",
    name: "attributes",
    meta:{id:5,title:"لیست ویژگیهای محصول",Auth:true},
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/basesetting/attribute.vue")
  },
  {
    path: "/manage/basesetting/product/valueattribute",
    name: "valueattributes",
    meta:{id:90011,title:"لیست ویژگیهای قیمت",Auth:true},
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/basesetting/vattribute.vue")
  },
  {
    path: "/manage/basesetting/product/formula",
    meta:{id:6,title:"لیست فرمول قیمت ها",Auth:true},
    name: "formula",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/basesetting/formula.vue")
  },
  {
    path: "/manage/basesetting/product/label",
    meta:{id:7,title:"لیست برچسب محصولات",Auth:true},
    name: "labels",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/basesetting/product-label.vue")
  },
  {
    path: "/manage/faq/category",
    meta:{id:1076,title:"دسته بندی سوالات متداول",Auth:true},
    name: "faqcats",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/basesetting/faqcat.vue")
  },
  {
    path: "/manage/faq/answers",
    meta:{id:1077,title:" سوالات متداول",Auth:true},
    name: "faq",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/basesetting/faq.vue")
  },
  {
    path: "/manage/basesetting",
    meta:{id:1091,title:"تنظیمات سایت",Auth:true},
    name: "setting",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/basesetting/setting.vue")
  },
  // {
  //   path: "/manage/basesetting/product/warranty",
  //   meta:{id:1016,title:"گارانتی محصولات",Auth:true},
  //   name: "warranties",
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/basesetting/product-warranty.vue")
  // },
  {
    path: "/manage/product/physical",
    meta:{id:8,title:"لیست محصولات",Auth:true},
    name: "physical",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/product/physical/product.vue")
  },
  // {
  //   path: "/manage/product/digital",
  //   name: "digital",
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/product/digital/product.vue")
  // },
  // {
  //   path: "/manage/product/training",
  //   name: "training",
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/product/training.vue")
  // },
  {
    path: "/manage/basesetting/product/coppon",
    name: "coppon",
    meta:{id:9,title:"لیست تخفیفات",Auth:true},
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/basesetting/coppon.vue")
  },  
  {
    path: "/manage/basesetting/product/festival",
    name: "festival",
    meta:{id:1050,title:"تخفیفات جشنواره ای",Auth:true},
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/basesetting/festival.vue")
  },
  /******Content Management Routing */
  {
    path: "/manage/content/departments",
    meta:{id:10,title:"صفحه دپارتمان ها",Auth:true},
    name: "departments",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/pages/department.vue")
  },
  {
    path: "/manage/content/brandlist",
    meta:{id:1099,title:"صفحه لیست برند ها",Auth:true},
    name: "brandlist",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/pages/brandlist.vue")
  },
  {
    path: "/manage/content/compare",
    meta:{id:666632,title:"صفحه مقایسه",Auth:true},
    name: "compare",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/pages/compare.vue")
  },
  {
    path: "/manage/content/shopseo",
    meta:{id:98565,title:"صفحه فروشگاه",Auth:true},
    name: "shopseo",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/pages/shopseo.vue")
  },
  {
    path: "/manage/content/cataloglist",
    meta:{id:1100,title:"صفحه لیست کاتالوگ ",Auth:true},
    name: "cataloglist",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/pages/cataloglist.vue")
  },
  {
    path: "/manage/content/videogallery",
    meta:{id:1101,title:"صفحه  گالری ویدئو ",Auth:true},
    name: "videogallery",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/pages/videogallery.vue")
  },
  {
    path: "/manage/content/disocuntedproduct",
    meta:{id:1102,title:"صفحه  محصولات تخفیف دار ",Auth:true},
    name: "discountedproduct",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/pages/discountedproduct.vue")
  },

  {
    path: "/manage/content/certificates",
    meta:{id:1001,title:"صفحه گواهینامه ها",Auth:true},
    name: "certificates",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/pages/certificates.vue")
  },
  {
    path: "/manage/content/userstatics",
    meta:{id:60001,title:"صفحه محتوای بخش کاربری",Auth:true},
    name: "userstatics",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/pages/user/userpages.vue")
  },
  {
    path: "/manage/content/history",
    meta:{id:1002,title:"صفحه  تاریخچه فعالیت",Auth:true},
    name: "history",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/pages/history.vue")
  },
  {
    path: "/manage/content/return-product",
    meta:{id:1003,title:"صفحه مرجوعی کالا",Auth:true},
    name: "returnproduct",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/pages/return-product.vue")
  },

  {
    path: "/manage/content/shopsections",
    meta:{id:100001,title:"  بخش های  فروشگاه",Auth:true},
    name: "shopsections",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/pages/shop.vue")
  },
  {
    path: "/manage/content/indexsections",
    meta:{id:11,title:"  بخش های صفحه اصلی",Auth:true},
    name: "indexsections",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/pages/index.vue")
  },
  {
    path: "/manage/content/lightbox",
    meta:{id:12,title:"لایت باکس صفحه اصلی",Auth:true},
    name: "lightbox",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/pages/lightbox.vue")
  },
  {
    path: "/manage/content/indexseo",
    meta:{id:13,title:"سئو صفحه اصلی",Auth:true},
    name: "indexseo",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/pages/indexseo.vue")
  },  
  // {
  //   path: "/manage/content/indexfooterlogo",
  //   meta:{id:1070,title:"لوگو های فوتر",Auth:true},
  //   name: "footerlogo",
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/basesetting/footerlogo.vue")
  // },
  {
    path: "/manage/content/contactus",
    meta:{id:14,title:"صفحه  تماس با ما",Auth:true},
    name: "contactus",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/pages/contact-us.vue")
  },
  // {
  //   path: "/manage/content/consult",
  //   meta:{id:15,title:"صفحه  درخواست آفلاین",Auth:true},
  //   name: "consult",
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/content/pages/consult.vue")
  // },
  {
    path: "/manage/content/aboutus",
    meta:{id:16,title:"صفحه  درباره ما",Auth:true},
    name: "aboutus",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/pages/about-us.vue")
  },


  {
    path: "/manage/content/updateprice",
    meta:{id:1061,title:"صفحه بروزترین قیمت ها",Auth:true},
    name: "updateprice",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/pages/updateprice.vue")
  },
  {
    path: "/manage/content/dailyoffers",
    meta:{id:1062,title:"صفحه تخفیفات روزانه",Auth:true},
    name: "dailyoffers",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/pages/dailyoffers.vue")
  },
  {
    path: "/manage/content/shop_profits",
    meta:{id:3336,title:"مدیریت مزایای فروشگاه",Auth:true},
    name: "shhopprofits",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/pages/profits-shop.vue")
  },
  {
    path: "/manage/content/profits",
    meta:{id:1052,title:"مدیریت مزایا",Auth:true},
    name: "profits",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/pages/profits.vue")
  },
  // {
  //   path: "/manage/special/auctions",
  //   meta:{id:1052,title:"مدیریت مزایدات",Auth:true},
  //   name: "auctions",
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/special/auction.vue")
  // },
  // {
  //   path: "/manage/special/auctions/detail/:id",
  //   meta:{id:1052,title:"مدیریت مزایدات",Auth:true},
  //   name: "auctions",
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/special/detail.vue")
  // },
  {
    path: "/manage/content/goalspolicy",
    name: "golaspolicy",
    meta:{id:18,title:"صفحه اهداف و خط مشی",Auth:true},
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/pages/goalspolicy.vue")
  },
  {
    path: "/manage/content/termsconditions",
    meta:{id:19,title:"صفحه  قوانین و مقررات",Auth:true},
    name: "termsconditions",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/pages/termsandconditions.vue")
  },
  {
    path: "/manage/content/faq",
    meta:{id:20,title:"صفحه سوالات متداول",Auth:true},
    name: "faqpage",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/pages/faq.vue")
  },
  {
    path: "/manage/content/regguid",
    meta:{id:21,title:"صفحه  راهنمای ثبت نام",Auth:true},
    name: "registerationguid",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/pages/registration-guid.vue")
  },
  {
    path: "/manage/content/physicalpurchasetraining",
    meta:{id:22,title:"صفحه راهنمای خرید محصول",Auth:true},
    name: "physicalpurchase",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/pages/physical-purchase.vue")
  },

  {
    path: "/manage/content/exportrequestpage",
    meta:{id:22,title:"صفحه درخواست صادرات محصول",Auth:false},
    name: "exportrequestpage",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/pages/export.vue")
  },
  {
    path: "/manage/content/majorrequestpage",
    meta:{id:22,title:"صفحه سفارش عمده محصول",Auth:false},
    name: "majorrequestpage",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/pages/major.vue")
  },
  {
    path: "/manage/content/productionrequestpage",
    meta:{id:22,title:"صفحه سفارش تولید",Auth:false},
    name: "productionrequestpage",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/pages/production.vue")
  },
  {
    path: "/manage/content/physicalpurchasetraining",
    meta:{id:22,title:"صفحه راهنمای خرید محصول",Auth:true},
    name: "physicalpurchase",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/pages/physical-purchase.vue")
  },


  {
    path: "/manage/content/physicalreciept",
    meta:{id:23,title:"صفحه راهنمای دریافت محصول",Auth:true},
    name: "physicalreciept",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/pages/physical-reciept.vue")
  },
 
  {
    path: "/manage/content/userarea",
    name: "userarea",
    meta:{id:24,title:"صفحه  راهنمای ناحیه کاربری",Auth:true},
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/pages/user-area.vue")
  },
  /************ */
  {
    path: "/manage/content/catalog/category",
    meta:{id:1089,title:"  دسته بندی  کاتالوگ",Auth:true},
    name: "catalogcategory",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/category/gallery/catalog-category.vue")
  },
  {
    path: "/manage/content/image_gallery/category",
    meta:{id:25,title:"  دسته بندی گالری تصاویر",Auth:true},
    name: "igcategory",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/category/gallery/image-category.vue")
  },
  {
    path: "/manage/content/certificate/list",
    meta:{id:26,title:"مدیریت گواهینامه ها",Auth:true},
    name: "certificates",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/certificate/list.vue")
  },
  {
    path: "/manage/content/image_gallery/gallery",
    meta:{id:26,title:"گالری تصاویر",Auth:true},
    name: "imggallery",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/image-gallery/gallery.vue")
  },
  {
    path: "/manage/content/catalog",
    meta:{id:1088,title:"کاتالوگ و بروشور",Auth:true},
    name: "catalog",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/catalog/catalog.vue")
  },
  {
    path: "/manage/content/slider",
    meta:{id:27,title:"اسلایدر صفحه اصلی",Auth:true},
    name: "slider",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/slider/slider.vue")
  },
  {
    path: "/manage/content/shop_slider",
    meta:{id:931,title:"اسلایدر فروشگاه ",Auth:true},
    name: "slidershop",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/slider/slider-shop.vue")
  },
  {
    path: "/manage/requests/invoices",
    meta:{id:28,title:"مدیریت سفارشات",Auth:true},
    name: "invoices",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/request/invoice.vue")
  },
  {
    path: "/manage/requests/preorder",
    meta:{id:632145,title:"مدیریت پیش سفارشات",Auth:true},
    name: "preorders",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/request/preorder.vue")
  },
  {
    path: "/manage/content/addresses",
    meta:{id:3010,title:" مدیریت آدرس ها",Auth:true},
    name: "addresses",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/pages/addresses.vue")
  },
  {
    path: "/manage/requests/golddelivery",
    meta:{id:29,title:"تحویل فیزیکی  طلا",Auth:true},
    name: "golddelivery",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/request/golddelivery.vue")
  },
  {
    path: "/manage/requests/cashrequest",
    meta:{id:29,title:"برداشت نقدی وجه   ",Auth:true},
    name: "cashrequest",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/request/cashrequest.vue")
  },
  // {
  //   path: "/manage/pages/warranty",
  //   meta:{id:29,title:"مدیریت  ضمانت نامه",Auth:true},
  //   name: "warrantyinfo",
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/content/pages/warranty.vue")
  // },
  {
    path: "/manage/requests/comments",
    meta:{id:2211,title:"مدیریت نظرات",Auth:true},
    name: "comments",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/request/comments.vue")
  },
  {
    path: "/manage/requests/tickets",
    meta:{id:2211,title:"مدیریت تیکت ها",Auth:true},
    name: "tickets",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/request/ticket.vue")
  },
  {
    path: "/manage/requests/tickets/:code",
    meta:{id:774552,title:"مدیریت تیکت ",Auth:true},
    name: "ticketdetail",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/request/ticket-detail.vue")
  },
  {
    path: "/manage/requests/availablerequest",
    meta:{id:1082,title:"مدیریت درخواست  موجودی",Auth:true},
    name: "availablerequest",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/request/availablerequest.vue")
  },

  /****************************** */
  /************ */
  {
    path: "/manage/content/video_gallery/category",
    meta:{id:30,title:"دسته بندی گالری ویدئو",Auth:true},
    name: "vgcategory",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/category/gallery/video-category.vue")
  },
  {
    path: "/manage/content/video_gallery/gallery",
    meta:{id:31,title:"گالری ویدئو",Auth:true},
    name: "vggallery",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/content/video-gallery/gallery.vue")
  },
  /****************************** */
  /************ */
    {
      path: "/manage/notices/news/category",
      meta:{id:32,title:"دسته بندی اخبار",Auth:true},
      name: "newscategory",
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/category/notices/news-category.vue")
    },
    {
      path: "/manage/notices/news",
      meta:{id:33,title:"اخبار",Auth:true},
      name: "news",
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/notices/news.vue")
    },
    /****************************** */
    /************ */
    // {
    //   path: "/manage/notices/article/category",
    //   name: "articlecategory",
    //   meta:{id:34,title:"دسته بندی مقالات"},
    //   component: () =>
    //     import(/* webpackChunkName: "about" */ "../views/category/notices/article-category.vue")
    // },
    // {
    //   path: "/manage/notices/article",
    //   meta:{id:35,title:"مقالات"},
    //   name: "article",
    //   component: () =>
    //     import(/* webpackChunkName: "about" */ "../views/notices/article.vue")
    // },
    {
      path: "/manage/communication/export",
      meta:{id:36,title:"مدیریت فرم صادرات",Auth:false},
      name: "exportForm",
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/communication/export.vue")
    },
    {
      path: "/manage/communication/major",
      meta:{id:36,title:"مدیریت فرم درخواست عمده محصول",Auth:false},
      name: "majorForm",
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/communication/major.vue")
    },
    {
      path: "/manage/communication/production",
      meta:{id:36,title:"مدیریت فرم درخواست تولید",Auth:false},
      name: "productionForm",
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/communication/production.vue")
    },
    {
      path: "/manage/communication/suggest",
      meta:{id:36,title:"مدیریت فرم تماس با ما",Auth:true},
      name: "suggestForm",
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/communication/suggest.vue")
    },
    // {
    //   path: "/manage/communication/consult",
    //   meta:{id:37,title:"مدیریت فرم مشاوره",Auth:true},
    //   name: "consultForm",
    //   component: () =>
    //     import(/* webpackChunkName: "about" */ "../views/communication/consult.vue")
    // },
    {
      path: "/manage/communication/newsletter",
      meta:{id:38,title:"مدیریت خبرنامه",Auth:true},
      name: "newsletterForm",
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/communication/newsletter.vue")
    },
    {
      path: "/login",
      name: "login",
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/login.vue")
    },
    /****************************** */
    ////Promotions
    {
      path: "/manage/basesetting/promotions/specialsale",
      meta:{id:1040,title:"فروش ویژه",Auth:true},
      name: "specialsale",
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/promotions/special-sale.vue")
    },
    {
      path: "/manage/basesetting/promotions/imagebox",
      meta:{id:1041,title:"باکس های تصویری",Auth:true},
      name: "imagebox",
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/promotions/imagebox.vue")
    },
    {
      path: "/manage/basesetting/promotions/moveablebox",
      meta:{id:1042,title:"باکس های متحرک",Auth:true},
      name: "moveablebox",
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/promotions/moveablebox.vue")
    },
    {
      path: "/manage/basesetting/promotions/shopmoveablebox",
      meta:{id:4589,title:"باکس های متحرک فروشگاه",Auth:true},
      name: "moveableboxshop",
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/promotions/moveablebox-shop.vue")
    },
    ///
    ////Reports
    // {
    //   path: "/manage/reports/sale/byproduct",
    //   meta:{id:1020,title:"گزارش فروش بر اساس محصول",Auth:true},
    //   name: "salereportbyproduct",
    //   component: () =>
    //     import(/* webpackChunkName: "about" */ "../views/report/sale/byproduct.vue")
    // },

    ///
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});
router.beforeEach((to, from, next) => {
  console.warn(Store);
  if (to.matched.some(record => record.meta.Auth) && Store.state.LoggedIn == false  && to.name != "login") {
      // You can use store variable here to access globalError or commit mutation 
      // next("/login")
      next()
  } else {
      next()
  }
})
export default router;
